// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"preMadeReportCard_wrapper__biwxW","contentBox":"preMadeReportCard_contentBox__24I_U","label":"preMadeReportCard_label__3bOzD","date":"preMadeReportCard_date__dkNuD"};